export enum RuleEnum {
  RULE = 0,
  SCENARIO = 1,
  COMPOSITE_RULE = 2,
}

export enum RecipientEnum {
  TO = 0,
  CC = 1,
  BCC = 2,
  WEB_RECEIVER = 3,
  SMS = 4,
}

export enum SemanticValidatorType {
  Distance_SV = 1,
  Height_SV = 2,
  Vehicle_SV = 3,
  Financial_SV = 4,
}
